export const statLabels: Record<string, string> = {
  kick: 'Tiro', dribble: 'Regate', pass: 'Pase', defense: 'Defensa',
  speed: 'Velocidad', power: 'Potencia', control: 'Control', stamina: 'Resistencia',
};

type StatRadarProps = {
  stats: Record<string, number>;
  compareStats?: Record<string, number>;
  className?: string;
};

/** The same eight-axis player profile used in the player file and comparisons. */
export function StatRadar({ stats, compareStats, className = '' }: StatRadarProps) {
  const entries = Object.entries(stats).slice(0, 8);
  const center = 150;
  const radius = 100;
  // A radar must scale with an uncapped stat; otherwise values above 100 draw
  // outside its frame and look like they were silently capped.
  const maximum = Math.max(100, ...Object.values(stats), ...(compareStats ? Object.values(compareStats) : []));
  const point = (index: number, value = 1) => {
    const angle = -Math.PI / 2 + index * Math.PI * 2 / entries.length;
    return [center + Math.cos(angle) * radius * value, center + Math.sin(angle) * radius * value] as const;
  };
  const polygonFor = (values: Record<string, number>) => entries
    .map(([key], index) => point(index, (values[key] ?? 0) / maximum).join(','))
    .join(' ');

  return <svg className={`stat-radar ${className}`.trim()} viewBox="0 0 300 300" role="img" aria-label={compareStats ? 'Radar comparativo de atributos' : 'Radar de atributos'}>
    {[.25, .5, .75, 1].map((level) => <polygon key={level} points={entries.map((_, index) => point(index, level).join(',')).join(' ')} className="radar-grid" />)}
    {entries.map((_, index) => { const [x, y] = point(index); return <line x1={center} y1={center} x2={x} y2={y} className="radar-axis" key={index} />; })}
    {compareStats && <polygon points={polygonFor(compareStats)} className="radar-value radar-value--comparison" />}
    <polygon points={polygonFor(stats)} className="radar-value radar-value--primary" />
    {entries.map(([key, value], index) => { const [x, y] = point(index, 1.22); return <text x={x} y={y} textAnchor="middle" dominantBaseline="middle" key={key}><tspan x={x}>{statLabels[key] ?? key}</tspan><tspan x={x} dy="17" className="radar-number">{value}</tspan></text>; })}
  </svg>;
}
